import React from 'react'
import './header.css'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
const Header = () => {
    const [showModal, setShowModal] = useState(false)
    const [bgColor, setBgColor] = useState(false)
    const changeOnScroll = ()=>{
        if(window.scrollY >= 90){
            setBgColor(true)
        }
        else{
            setBgColor(false)
        }
    }
    window.addEventListener('scroll', changeOnScroll)
    const navigate = useNavigate()
  return (
    <motion.header className={`${bgColor && 'scroll-color'}`}
        initial={{ opacity:0}}
        animate={{opacity:1}}
        transition={{duration:0.65}}
    >
        <div className="logo-container">
            <img src="/full-logo.png" alt="company_logo" className='logo' onClick={()=>{
                navigate('/')
            }}/>
        </div>
        <nav>
            <ul>
                <li>
                    <Link to="/">Home</Link>
                    <span className='line'></span>
                </li>
                <li>
                    <Link to="/#about">About</Link>
                    <span className='line'></span>
                </li>
                <li>
                    <Link to="/#faq">Faqs</Link>
                    <span className='line'></span>
                </li>
                <li>
                    <Link to="https://qfs-vault.net/">Qsf vault</Link>
                    <span className='line'></span>
                </li>

                <li>
                    <Link to="#hiw">How it Works</Link>
                    <span className='line'></span>
                </li>

                <li>
                    <Link to="#rn">Recent News</Link>
                    <span className='line'></span>
                </li>

                <li>
                    <Link to="#t">Testimonials</Link>
                    <span className='line'></span>
                </li>
                
            </ul>
        </nav>
        <div className="sign-up-btn-container">
            <button className='signup-btn' onClick={()=>{navigate('/login')}}>login</button>
        </div>
        <div class="mobile-menu-container" onClick={()=>{
            setShowModal(!showModal)
          }} >  
                <div class="line1"></div>
                <div class="line2"></div>
                <div class="line3"></div>
          </div>
          <div className={`overlay ${showModal ? 'showing-modal' : ''}`} onClick={() => {
              setShowModal(false)
          }}>
                <div className={`menu-modal `} >
                <ul>
                    <Link to='/'>home</Link>
                    <Link to='/#about'>about</Link>
                    <Link to='/#faq'>faq</Link>
                    {/* <Link to='https://qfs-vault.net/'>Qsf vault</Link> */}
                    <Link to='#hiw'>How it Works</Link>
                    <Link to='#rn'>Recent News</Link>
                    <Link to='#t'>Testimonials</Link>
                    <Link to='/signup'>signup</Link>
                    <Link to='/login'>login</Link>
                </ul>
                </div>
              </div>
    </motion.header>
  )
}

export default Header